import React, { useState, createContext, useContext } from 'react';
interface UpsellContextValue {
  isOpen: boolean;
  openUpsell: () => void;
  closeUpsell: () => void;
}
const UpsellContext = createContext<UpsellContextValue | undefined>(undefined);
export function UpsellProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openUpsell = () => setIsOpen(true);
  const closeUpsell = () => setIsOpen(false);
  return <UpsellContext.Provider value={{
    isOpen,
    openUpsell,
    closeUpsell
  }} data-id="element-225">
      {children}
    </UpsellContext.Provider>;
}
export function useUpsell(): UpsellContextValue {
  const ctx = useContext(UpsellContext);
  if (!ctx) {
    throw new Error('useUpsell must be used within an UpsellProvider');
  }
  return ctx;
}